<template>
  <div class="wrapper">
    <div v-if="fireIsReady" class="background">
      <div class="resavationText">
        Indstillinger
      </div>
      <div class="infoOverview">
        <div class="descriptionText">
          <div class="headText">
            VaskerumsID
          </div>
          <div class="contentText">
            {{roomID}}
          </div>
          <div class="headText">
            Åbningstid
          </div>
          <div class="contentText">
            Åben fra kl. {{bookingTimeComputed.startHour}}:{{bookingTimeComputed.startMinutes}} til
            {{bookingTimeComputed.endHour}}:{{bookingTimeComputed.endMinutes}}
          </div>
          <div class="headText">
            Maskiner
          </div>
          <div class="contentText">
            <div v-if="fireSettings.washMachineAmount > 1">
              Vaskemaskiner: {{fireSettings.washMachineAmount}}
            </div>
            <div v-else>
              Vaskemaskine: {{fireSettings.washMachineAmount}}
            </div>
            <div v-if="fireSettings.dryerMachineAmount > 1">
              Tørretumblere: {{fireSettings.dryerMachineAmount}}
            </div>
            <div v-else>
              Tørretumbler: {{fireSettings.dryerMachineAmount}}
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- {{fireSettings}} -->
  </div>
</template>

<script>
import { db } from '@/firebase'
export default {
  data () {
    return {
      roomID: this.$laundryRoom,
      fireIsReady: false

    }
  },
  firebase () {
    return {
      fireSettings: {
        source: db.ref('laundryrooms/' + this.$laundryRoom + '/settings').orderByChild('start'),
        asObject: true,
        readyCallback: function (data) {
          this.fireIsReady = true
          // this.settings = data.val()
        }
      }
    }
  },
  computed: {
    bookingTimeComputed: function() {
      let startHour = this.fireSettings.startHour.toString()
      let startMinutes = this.fireSettings.startMinutes.toString()
      let endHour = this.fireSettings.endHour.toString()
      let endMinutes = this.fireSettings.endMinutes.toString()

      if (startHour.length == 1) {
        startHour = '0' + startHour
      }
      if (startMinutes.length == 1) {
        startMinutes = '0' + startMinutes
      }
      if (endHour.length == 1) {
        endHour = '0' + endHour
      }
      if (endMinutes.length == 1) {
        endMinutes = '0' + endMinutes
      }

      const bookingTime = {
        startHour: startHour,
        startMinutes: startMinutes,
        endHour: endHour,
        endMinutes: endMinutes
      }
      return bookingTime
    }
  }
}
</script>

<style scoped>

.wrapper {
  margin-top: 20px;
}

.infoOverview {
  text-align: left;
  margin-top: 0px;
}

.contentText {
  text-align: left;
  padding-left: 0px;
}

.descriptionText {
  text-align: center;
  font-size: 0.9rem;
  color: rgba(0,0,0,0.8);
}

.headText {
  text-align: left;
  font-weight: bold;
  margin-top: 10px;
  margin-bottom: 3px;
}

.background {
  padding: 0px 20px 20px 20px;
  /* background: orange; */
}

.resavationText {
  font-size: 1.7rem;
  font-weight: 400;
  color: rgba(0,0,0,0.8);
}

</style>



// WEBPACK FOOTER //
// src/components/roomInfo.vue